<template>

  <div class="card row justify-content-start align-items-center">
    <h3 class="my-caps mobile">4-Belt</h3>
    <div class="row belt">
      <div class="image col-md-6 d-flex is-align-items-center">
        <video autoplay loop muted playsinline>
          <source
              src="/media/videos/video_drone_corporate.mp4"
              type="video/mp4"/>
        </video>
      </div>
      <div class="my-text col-md-6 d-flex is-align-items-center">
        <div class="row primo">
          <div class="col-md-12 description">
            <h3 class="my-caps desktop">{{ trans.get('public.home.our-products.titolo2') }}</h3>
            <p>
              {{ trans.get('public.home.our-products.desc3') }}
            </p>
            <p class="desc3a">
              {{ trans.get('public.home.our-products.desc3a') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <h3 class="my-caps mobile">{{ trans.get('public.home.our-products.our-story') }}</h3>
    <div class="row story">
      <div class="col-md-6 description">
        <h3 class="my-caps desktop">{{ trans.get('public.home.our-products.our-story') }}</h3>
        <p>
          {{ trans.get('public.home.our-products.desc4') }}
        </p>
      </div>
      <div class="image col-md-6">
        <img src="/media/image-page/home-gallery/foto-gallery3.jpg" alt=""/>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "ns-prodotti-card-2",
  // props: ["reverse"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>

h3 {
  font-weight: normal;
  text-transform: unset;
  &.mobile {
    display: none;
  }
}
.row {
  max-width: 100%;
 &.belt {
   margin-bottom: 50px;
 }
}
.card {
  font-size: 1em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
  background-color: inherit !important;
  flex-direction: row;
  border: 0;
  box-shadow: unset;
  .desc3a {
    color: var(--greenb2b);
    font-size: 1.2em;
  }
  .image {
    padding: 0;
    img {
      height: 90%;
    }
  }
}

.description {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.row {
  color: #fff;

  h3 {
    color: #fff;
  }
}

@media (max-width: 576px) {
    h3 {
      font-size: 18px;
      text-transform: unset;
      margin-bottom: 10px;
      margin-left: 20px;
    }

    .card {
      img {
        height: 215px;
      }
      .row {
        margin-top: 0;
        .image {
          width: 100%;
          height: 100%;
          padding: 0;
          video {
            object-fit: cover;
            width: 100%;
          }
        }
        .my-text {
          padding: 0;
          .row {
            .description {
              margin-top: 20px;
              padding: 0 20px;
            }
          }
        }
        .description {
          margin-top: 20px;
          padding: 0 20px;
        }
      }
      .row.story {
        height: 100%;
        flex-direction: column-reverse;
      }
      .my-caps.mobile {
        display: block;
      }
      .my-caps.desktop {
        display: none;
      }
    }

}
@media (min-width: 1921px) {

}
</style>
